module.exports = __webpack_public_path__ + "img/05d_Buy_651.2531f289.jpg";